module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "bar bar-nav border",
    staticStyle: {
      "margin-left": "0rem"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "width": "12%"
    }
  }, [_c('a', {
    staticClass: "item-link item-content",
    staticStyle: {
      "float": "right",
      "position": "relative",
      "margin-top": "4px"
    },
    on: {
      "click": function($event) {
        return _vm.gotoMymessage()
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": "2.2rem",
      "height": "2rem"
    },
    attrs: {
      "src": "/static/img/kefu.png"
    }
  }), _vm._v(" "), (_vm.curMessageSession.unreadMessagesAmount > 0) ? _c('span', {
    staticClass: "unreadmessage"
  }, [_vm._v("\n           " + _vm._s(_vm.curMessageSession.unreadMessagesAmount))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "list-block media-list person-card",
    staticStyle: {
      "margin-top": "-2px",
      "margin-bottom": "-25px"
    }
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "item-content"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "item-inner",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('div', {
    staticClass: "item-title-row"
  }, [(_vm.sessionInfo.customerNo !== 'GUEST') ? _c('div', {
    staticClass: "item-title"
  }, [_vm._v(_vm._s(_vm.sessionInfo.customerInfo.customerName))]) : _vm._e()]), _vm._v(" "), (_vm.sessionInfo.customerNo !== 'GUEST') ? _c('div', {
    staticClass: "item-subtitle"
  }, [_vm._v(_vm._s(_vm.sessionInfo.customerInfo.customerNo))]) : _vm._e(), _vm._v(" "), (_vm.sessionInfo.customerNo !== 'GUEST') ? _c('div', {
    staticClass: "item-text",
    staticStyle: {
      "height": "1rem"
    }
  }, [_vm._v(_vm._s(_vm.sessionInfo.customerInfo.enterpriseName))]) : _vm._e()])])])])]), _vm._v(" "), (_vm.sessionInfo.customerInfo && _vm.sessionInfo.customerInfo.ssoFlag === 0) ? _c('div', {
    staticClass: "row text-center",
    staticStyle: {
      "height": "15%",
      "border": "1px solid #ccc",
      "background": "white",
      "margin-top": "1.5rem"
    }
  }, [_c('div', {
    staticClass: "col-20 border",
    staticStyle: {
      "width": "16%"
    },
    on: {
      "click": function($event) {
        return _vm.toOrderDetail(1)
      }
    }
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "color-gray font-size"
  }, [_c('img', {
    staticClass: "icon-order-pay",
    attrs: {
      "src": _vm.baseUrl + 'me_pay.png'
    }
  })]), _vm._v(" "), (_vm.myOrder.waitPaidOrders && _vm.myOrder.waitPaidOrders.length > 0) ? _c('span', {
    staticClass: "orderNum"
  }, [_vm._v(_vm._s(_vm.myOrder.waitPaidOrders.length))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-20 border",
    staticStyle: {
      "width": "16%"
    },
    on: {
      "click": function($event) {
        return _vm.toOrderDetail(2)
      }
    }
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "color-gray font-size"
  }, [_c('img', {
    staticClass: "icon-order-pay",
    attrs: {
      "src": _vm.baseUrl + 'me_receive.png'
    }
  })]), _vm._v(" "), (_vm.myOrder.waitDeliverOrders && _vm.myOrder.waitDeliverOrders.length > 0) ? _c('span', {
    staticClass: "orderNum"
  }, [_vm._v(_vm._s(_vm.myOrder.waitDeliverOrders.length))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-20 border",
    staticStyle: {
      "width": "16%"
    }
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "color-gray font-size"
  }, [_c('img', {
    staticClass: "icon-order-pay",
    attrs: {
      "src": _vm.baseUrl + 'me_estimate.png'
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-20 border",
    staticStyle: {
      "width": "16%"
    },
    on: {
      "click": function($event) {
        return _vm.toOrderDetail(3)
      }
    }
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "color-gray font-size"
  }, [_c('img', {
    staticClass: "icon-order-pay",
    attrs: {
      "src": _vm.baseUrl + 'me_complete.png'
    }
  })]), _vm._v(" "), (_vm.myOrder.finishedOrders && _vm.myOrder.finishedOrders.length > 0) ? _c('span', {
    staticClass: "orderNum"
  }, [_vm._v(_vm._s(_vm.myOrder.finishedOrders.length))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-20 border",
    staticStyle: {
      "width": "16%"
    },
    on: {
      "click": function($event) {
        return _vm.toOrderDetail(4)
      }
    }
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "color-gray font-size"
  }, [_c('img', {
    staticClass: "icon-order-pay",
    attrs: {
      "src": _vm.baseUrl + 'me_cancel.png'
    }
  })]), _vm._v(" "), (_vm.myOrder.canceledOrders && _vm.myOrder.canceledOrders.length > 0) ? _c('span', {
    staticClass: "orderNum"
  }, [_vm._v(_vm._s(_vm.myOrder.canceledOrders.length))]) : _vm._e()])]) : _c('div', {
    staticClass: "row text-center",
    staticStyle: {
      "height": "15%",
      "border": "1px solid #ccc",
      "background": "white",
      "margin-top": "1.5rem"
    }
  }, [_c('div', {
    staticClass: "col-20 border",
    staticStyle: {
      "width": "16%"
    },
    on: {
      "click": function($event) {
        return _vm.toOrderDetail(10)
      }
    }
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "color-gray font-size"
  }, [_vm._v("审核失败")]), _vm._v(" "), (_vm.myOrder.failAuditOrders && _vm.myOrder.failAuditOrders.length > 0) ? _c('span', {
    staticClass: "orderNum"
  }, [_vm._v(_vm._s(_vm.myOrder.failAuditOrders.length))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-20 border",
    staticStyle: {
      "width": "16%"
    },
    on: {
      "click": function($event) {
        return _vm.toOrderDetail(6)
      }
    }
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "color-gray font-size"
  }, [_vm._v("待审核")]), _vm._v(" "), (_vm.myOrder.waitAuditOrders && _vm.myOrder.waitAuditOrders.length > 0) ? _c('span', {
    staticClass: "orderNum"
  }, [_vm._v(_vm._s(_vm.myOrder.waitAuditOrders.length))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-20 border",
    staticStyle: {
      "width": "16%"
    },
    on: {
      "click": function($event) {
        return _vm.toOrderDetail(7)
      }
    }
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "color-gray font-size"
  }, [_vm._v("报价完成")]), _vm._v(" "), (_vm.myOrder.quoteCompletedOrders && _vm.myOrder.quoteCompletedOrders.length > 0) ? _c('span', {
    staticClass: "orderNum"
  }, [_vm._v(_vm._s(_vm.myOrder.quoteCompletedOrders.length))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-20 border",
    staticStyle: {
      "width": "16%"
    },
    on: {
      "click": function($event) {
        return _vm.toOrderDetail(8)
      }
    }
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "color-gray font-size"
  }, [_vm._v("录入完成")]), _vm._v(" "), (_vm.myOrder.completeOrders && _vm.myOrder.completeOrders.length > 0) ? _c('span', {
    staticClass: "orderNum"
  }, [_vm._v(_vm._s(_vm.myOrder.completeOrders.length))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-20 border",
    staticStyle: {
      "width": "16%"
    },
    on: {
      "click": function($event) {
        return _vm.toOrderDetail(9)
      }
    }
  }, [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "color-gray font-size"
  }, [_vm._v("待签署")]), _vm._v(" "), (_vm.myOrder.waitSignOrders && _vm.myOrder.waitSignOrders.length > 0) ? _c('span', {
    staticClass: "orderNum"
  }, [_vm._v(_vm._s(_vm.myOrder.waitSignOrders.length))]) : _vm._e()]), _vm._v(" "), _vm._m(12)]), _vm._v(" "), _c('div', {
    staticClass: "list-block",
    staticStyle: {
      "display": "block",
      "margin-top": "0.2rem"
    }
  }, [_c('ul', [_c('li', [_c('router-link', {
    staticClass: "item-link item-content",
    attrs: {
      "to": {
        name: 'userInfo'
      }
    }
  }, [_c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-me"
  })]), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("个人信息")])])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "item-link item-content",
    attrs: {
      "to": {
        name: 'VipPlanDetails'
      }
    }
  }, [_c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-me"
  })]), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("我的大客户计划")])])])], 1), _vm._v(" "), (!_vm.isSFFlag) ? _c('li', [_c('router-link', {
    staticClass: "item-link item-content",
    attrs: {
      "to": {
        name: 'ResearchGroupHome'
      }
    }
  }, [_c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-me"
  })]), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("我的课题组")]), _vm._v(" "), (_vm.totalWaitApproveOrder) ? _c('div', {
    staticClass: "item-title-after wait-approve"
  }, [_vm._v(_vm._s(_vm.totalWaitApproveOrder))]) : _vm._e()])])], 1) : _vm._e(), _vm._v(" "), (_vm.myCoupons.length != 0) ? _c('li', [_c('div', {
    staticClass: "item-content"
  }, [_vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("我的优惠券")]), _vm._v(" "), _c('div', {
    staticClass: "item-title-after font-size"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'myCoupons'
      }
    }
  }, [_vm._v("共" + _vm._s(_vm.myCoupons.length) + "张优惠券\n                    "), (_vm.expireInOneDay) ? _c('span', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": ".6rem"
    }
  }, [_vm._v("优惠券即将过期")]) : _vm._e()])], 1)])])]) : _c('li', [_vm._m(14)]), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "item-link item-content",
    attrs: {
      "to": {
        name: 'myRecommend'
      }
    }
  }, [_c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-browser"
  })]), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("推荐给好友")])])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "item-link item-content",
    attrs: {
      "to": {
        name: 'passwordChange'
      }
    }
  }, [_c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-edit"
  })]), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("修改密码")])])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "item-link item-content",
    attrs: {
      "to": {
        name: 'WeappAddress'
      }
    }
  }, [_c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-edit"
  })]), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("收货地址管理")])])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "list-block",
    staticStyle: {
      "display": "block",
      "margin-top": "-25px"
    }
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "item-content"
  }, [_vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("我的信用")]), _vm._v(" "), (_vm.creditPay) ? _c('div', {
    staticClass: "item-title-after font-size"
  }, [_vm._v("\n                  " + _vm._s(_vm._f("currencyStyle")(_vm.sessionInfo.customerInfo.emktCreditBalance)) + "\n                ")]) : (_vm.creditStatus === 0) ? _c('div', {
    staticClass: "item-title-after font-size"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'applyCreditPay'
      }
    }
  }, [_vm._v("申请信用支付")])], 1) : _c('div', {
    staticClass: "item-title-after font-size"
  }, [_vm._v("\n                  " + _vm._s(_vm.payTypeApplyStatus) + "\n                  ")])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "item-content"
  }, [_vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("我的余额")]), _vm._v(" "), (_vm.moneyRemain) ? _c('div', {
    staticClass: "item-title-after font-size"
  }, [_vm._v("\n                  " + _vm._s(_vm._f("currencyStyle")(_vm.sessionInfo.customerInfo.prepayMoneyRemain)) + "\n                ")]) : _c('div', {
    staticClass: "item-title-after font-size"
  }, [_vm._v("\n                  " + _vm._s(_vm._f("currencyStyle")(0)) + "\n                ")])])])]), _vm._v(" "), (_vm.showBillInfo) ? _c('li', [_c('div', {
    staticClass: "item-content"
  }, [_vm._m(17), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("我的对账单")]), _vm._v(" "), _c('button', {
    staticClass: "item-title-after font-size",
    staticStyle: {
      "color": "#399FED"
    },
    on: {
      "click": function($event) {
        return _vm.getMyAccountChecked()
      }
    }
  }, [_vm._v("\n                            查看对账单\n                          ")])])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "list-block",
    staticStyle: {
      "display": "block",
      "margin-top": "-25px"
    }
  }, [_c('ul', [_c('li', [_c('router-link', {
    staticClass: "item-link item-content",
    attrs: {
      "to": {
        name: 'myAgreement'
      }
    }
  }, [_c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-menu"
  })]), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("注册协议")])])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "list-block",
    staticStyle: {
      "display": "block",
      "margin-top": "-25px"
    }
  }, [_c('ul', [_c('li', [_c('router-link', {
    staticClass: "item-link item-content",
    attrs: {
      "to": {
        name: 'contact'
      }
    }
  }, [_c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-message"
  })]), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("联系我们")])])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "list-block",
    staticStyle: {
      "display": "block",
      "margin-top": "-25px"
    }
  }, [_c('ul', [_c('li', [_c('router-link', {
    staticClass: "item-link item-content",
    attrs: {
      "to": {
        name: 'publicNumber'
      }
    }
  }, [_c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-code"
  })]), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("关注公众号")])])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "content-block"
  }, [_c('a', {
    staticClass: "button button-big button-fill button-danger external",
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("注销登录")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "40px"
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "float": "left",
      "width": "88%"
    }
  }, [_c('span', {
    staticStyle: {
      "text-align": "center",
      "display": "block",
      "margin-top": ".5rem"
    }
  }, [_vm._v("\n        个人中心\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-media"
  }, [_c('img', {
    staticStyle: {
      "border-radius": "50%"
    },
    attrs: {
      "src": require("./../../assets/timg.jpeg"),
      "width": "80"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "orderPic icon"
  }, [_c('img', {
    staticClass: "icon-order",
    attrs: {
      "src": "/emktResources/resocurces/img/icon/not_pay.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "orderPic icon"
  }, [_c('img', {
    staticClass: "icon-order",
    attrs: {
      "src": "/emktResources/resocurces/img/icon/not_receive.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "orderPic icon"
  }, [_c('img', {
    staticClass: "icon-order",
    attrs: {
      "src": "/emktResources/resocurces/img/icon/not_comment.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "orderPic icon"
  }, [_c('img', {
    staticClass: "icon-order",
    attrs: {
      "src": "/emktResources/resocurces/img/icon/complete.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "orderPic icon"
  }, [_c('img', {
    staticClass: "icon-order",
    attrs: {
      "src": "/emktResources/resocurces/img/icon/cancel.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "orderPic icon"
  }, [_c('img', {
    staticClass: "icon-order",
    attrs: {
      "src": "/emktResources/resocurces/img/icon/not_pay.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "orderPic icon"
  }, [_c('img', {
    staticClass: "icon-order",
    attrs: {
      "src": "/emktResources/resocurces/img/icon/not_pay.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "orderPic icon"
  }, [_c('img', {
    staticClass: "icon-order",
    attrs: {
      "src": "/emktResources/resocurces/img/icon/not_receive.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "orderPic icon"
  }, [_c('img', {
    staticClass: "icon-order",
    attrs: {
      "src": "/emktResources/resocurces/img/icon/not_comment.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "orderPic icon"
  }, [_c('img', {
    staticClass: "icon-order",
    attrs: {
      "src": "/emktResources/resocurces/img/icon/complete.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-20 border",
    staticStyle: {
      "width": "16%"
    }
  }, [_c('div', {
    staticClass: "orderPic icon"
  }, [_c('img', {
    staticClass: "icon-order",
    attrs: {
      "src": "/emktResources/resocurces/img/icon/cancel.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "color-gray font-size"
  }, [_vm._v("报价作废")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-gift"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-gift"
  })]), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("我的优惠券")]), _vm._v(" "), _c('div', {
    staticClass: "item-title-after font-size"
  }, [_vm._v("无")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-star"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-emoji"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-search"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-96425f96","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/User/Me.vue
// module id = 1697
// module chunks = 8